import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { apiClient } from '../config/apiClient';
import { LoginContext } from './loginContext';

export const ModulosContext = createContext();

const MODULOS_DEFAULT = {
  gestion: false,
  club: false,
  academia: false,
  sacarTurnoRequiereLogin: false,
};

export const ModulosProvider = ({ children }) => {
  const { user, isAuthenticated } = useContext(LoginContext);
  const [modulosActivos, setModulosActivos] = useState(MODULOS_DEFAULT);
  const [modulosLoaded, setModulosLoaded] = useState(false);

  const isAdmin =
    user?.tiu_descripcion?.toUpperCase() === 'ADMINISTRADOR' ||
    user?.usu_tipousuario === 1;

  const loadModulosConfig = async () => {
    if (!isAuthenticated) {
      setModulosActivos(MODULOS_DEFAULT);
      setModulosLoaded(true);
      return;
    }

    setModulosLoaded(false);
    try {
      if (!isAdmin) {
        const response = await apiClient.get('/public/portada');
        if (!response.ok) {
          setModulosActivos(MODULOS_DEFAULT);
          return;
        }
        const data = await response.json();
        const config = data?.config || {};
        setModulosActivos({
          gestion: false,
          club: Boolean(config.club),
          academia: Boolean(config.academia),
          sacarTurnoRequiereLogin: Boolean(config.sacarTurnoRequiereLogin),
        });
        return;
      }

      const response = await apiClient.get('/modulos/config');
      if (!response.ok) {
        setModulosActivos(MODULOS_DEFAULT);
        return;
      }
      const data = await response.json();
      setModulosActivos({
        gestion: Boolean(data.gestion),
        club: Boolean(data.club),
        academia: Boolean(data.academia),
        sacarTurnoRequiereLogin: Boolean(data.sacarTurnoRequiereLogin),
      });
    } catch (error) {
      console.error('Error al cargar configuración de módulos:', error);
      setModulosActivos(MODULOS_DEFAULT);
    } finally {
      setModulosLoaded(true);
    }
  };

  useEffect(() => {
    loadModulosConfig();
  }, [isAuthenticated, isAdmin, user?.id, user?.usu_id]);

  const value = useMemo(
    () => ({
      modulosActivos,
      modulosLoaded,
      isAdmin,
      reloadModulos: loadModulosConfig,
    }),
    [modulosActivos, modulosLoaded, isAdmin]
  );

  return (
    <ModulosContext.Provider value={value}>
      {children}
    </ModulosContext.Provider>
  );
};

export const useModulos = () => {
  const ctx = useContext(ModulosContext);
  if (!ctx) throw new Error('useModulos debe usarse dentro de ModulosProvider');
  return ctx;
};
